import { Image } from 'src/components/ui/Image'
import { Link } from 'gatsby'

interface BenefitBannerItem {
  imageDesktop: string
  imageMobile?: string
  title: string
  description?: string
  linkRedirect?: string
}

interface InsuranceSectionBenefitBannerProps {
  title?: string
  items: BenefitBannerItem[]
}

const InsuranceSectionBenefitBanner: React.FC<
  InsuranceSectionBenefitBannerProps
> = ({ title, items }) => {
  return (
    <section className="w-full md:max-h-[410px] bg-transparent md:bg-[#101010] py-10 md:mb-[240px]">
      <h2 className="text-black md:text-white text-font-size-8 md:text-3xl font-medium md:font-bold text-start md:text-center w-[343px] sm:w-full px-3 mb-4 md:mb-14">
        {title}
      </h2>
      <div className="flex max-w-[1280px] flex-col md:flex-row gap-4 md:gap-6 items-center md:items-stretch justify-center px-4 mx-auto">
        {items.map((item, idx) => (
          <Link
            to={item.linkRedirect ?? '#'}
            className={`relative w-full md:min-w-[630px] md:max-w-[630px] h-auto md:h-[400px] overflow-hidden
              ${item.linkRedirect ? 'cursor-pointer' : 'pointer-events-none'}`}
            target="_blank"
            rel="noopener noreferrer"
            key={idx}
          >
            <Image
              src={item.imageMobile ?? item.imageDesktop}
              srcSet={
                item.imageDesktop
                  ? `${item.imageMobile ?? item.imageDesktop} 767w, ${
                      item.imageDesktop
                    } 768w`
                  : undefined
              }
              alt="Banner Seguro Bike"
              className="w-full h-full object-cover"
            />
          </Link>
        ))}
      </div>
    </section>
  )
}

export default InsuranceSectionBenefitBanner
